<health-data-page
    [chartLabel]="chartLabel"
    [healthDataLabel]="healthDataLabel"
    [healthDataType]="restingHeartRateHealthDataType"
    [hasTwoDecimals]="hasTwoDecimals"
    [supportedPeriods]="supportedPeriods"
    [payloadTypes]="payloadTypes"
/>
